import { render, staticRenderFns } from "./TextBodyRegular.vue?vue&type=template&id=729ddade&scoped=true"
import script from "./TextBodyRegular.vue?vue&type=script&lang=js"
export * from "./TextBodyRegular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729ddade",
  null
  
)

export default component.exports